// Big countdown timer for the payment page. Highlights red < 5 min.
import { useEffect, useState } from "react";

function format(ms) {
  if (ms <= 0) return "00:00";
  const total = Math.floor(ms / 1000);
  const m = String(Math.floor(total / 60)).padStart(2, "0");
  const s = String(total % 60).padStart(2, "0");
  return `${m}:${s}`;
}

export function CountdownTimer({ expiresAt, onExpire, dataTestid = "countdown" }) {
  const [remaining, setRemaining] = useState(() =>
    expiresAt ? new Date(expiresAt).getTime() - Date.now() : 0
  );

  useEffect(() => {
    if (!expiresAt) return undefined;
    const tick = () => {
      const r = new Date(expiresAt).getTime() - Date.now();
      setRemaining(r);
      if (r <= 0 && typeof onExpire === "function") onExpire();
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [expiresAt, onExpire]);

  const danger = remaining > 0 && remaining < 5 * 60 * 1000;
  const expired = remaining <= 0;

  return (
    <div
      data-testid={dataTestid}
      className={[
        "rounded-2xl px-5 py-4 flex items-center justify-between gap-4 font-mono",
        expired
          ? "bg-red-50 border-2 border-red-300"
          : danger
          ? "bg-amber-50 border-2 border-amber-400 animate-pulse"
          : "bg-emerald-50 border-2 border-emerald-300",
      ].join(" ")}
    >
      <div>
        <div className={[
          "text-xs uppercase tracking-widest font-bold mb-0.5",
          expired ? "text-red-600" : danger ? "text-amber-600" : "text-emerald-700",
        ].join(" ")}>
          {expired ? "Reserva expirada" : "Pagamento expira em"}
        </div>
        <div className={[
          "text-4xl sm:text-5xl font-black tabular-nums tracking-tight leading-none",
          expired ? "text-red-700" : danger ? "text-amber-700" : "text-emerald-800",
        ].join(" ")}>
          {format(remaining)}
        </div>
      </div>
      <div className={[
        "text-3xl",
        expired ? "text-red-500" : danger ? "text-amber-500" : "text-emerald-500",
      ].join(" ")}>
        {expired ? "⏱️" : danger ? "⚠️" : "⏳"}
      </div>
    </div>
  );
}
